import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      height: 100%;\n      text-align: center;\n    "])));
  },
  rootAlignLeft: function rootAlignLeft() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      text-align: left;\n    "])));
  },
  rootAlignRight: function rootAlignRight() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      text-align: right;\n    "])));
  },
  spring: function spring() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      height: 100%;\n      vertical-align: middle;\n    "])));
  },
  container: function container() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      text-align: left;\n      vertical-align: middle;\n    "])));
  }
});